import {useRealtimeChannel} from "@/api/realtime/RealtimeChannelHooks.ts";
import {AreaEffect} from "@/encounter/model/AreaEffect.ts";

export type AreaEffectEvent = {
    upserted?: AreaEffect;
    removedId?: string;
};

export function useAreaEffectRealtime(encounterId: string) {
    const {subscribe} = useRealtimeChannel<AreaEffectEvent>(`/encounters/${encounterId}/effects`);
    return subscribe;
}
